/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { FlexCol, TextField } from 'sarsaparilla';

function flexTextAttributeInfo(props) {
    const { number, label, onChange, skipCustomerInfo, submitAttempted, value } = props;

    const handleChange = (e) => {
        const currentValue = e?.target?.value;
        const flexTextAttributeIsValid = !!currentValue;
        onChange(currentValue, flexTextAttributeIsValid);
    };

    if (!label) {
        return null;
    }

    return (
        <FlexCol lg={6}>
            <div className="rec-form-item-wrap">
                <TextField
                    label={label}
                    id={`flex-text-attr-${number}`}
                    isRequired={!skipCustomerInfo}
                    value={skipCustomerInfo ? '' : value}
                    isDisabled={skipCustomerInfo}
                    shouldValidateOnUpdate={submitAttempted}
                    onChange={(e) => handleChange(e)}
                />
            </div>
        </FlexCol>
    );
}

flexTextAttributeInfo.propTypes = {
    number: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    submitAttempted: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
};

export default flexTextAttributeInfo;
